import { RedirectionItem } from '../../types/app-redirection.types.ts';

export const APP_REDIRECTION_SLICE_NAME = 'appRedirection';

export interface AppRedirectionSliceState {
  redirectionItems: RedirectionItem[];
}
